<template>
  <transition name="fade">
  <div class="NameCard">
    <div class="container">
      <div class="columns">
        <div class="column col-12">
          <h2>{{name.value}}</h2>
        </div>
        <div class="column col-3">
        </div>
        <div class="column col-2">
          <StarRating :value="rating" v-on:change="starChange">
          </StarRating>
        </div>
      </div>
      <div class="columns center">
        <div class="column col-5">
          <Chat :nameRef="name" :addComment="addComment">
          </Chat>
        </div>
      </div>
    </div>
  </div>
</transition>
</template>

<script>

import StarRating from './StarRating'
import Chat from './Chat.vue'

export default {
  name: 'Card',
  props: ['name', 'addRating', 'removeRating', 'rating', 'addComment'],
  components: {
    StarRating,
    Chat,
  },
  data() {
    return {

    };
  },
  computed: {
    myRating: function() {
      if (this.name.rating && this.name.rating.marcus) {
        return this.name.rating.marcus
      } else {
        return -1
      }
    }
  },
  methods: {
    starChange: function(selected, current) {
      if (selected == current) {
        this.removeRating(this.name['.key'])
      } else {
        this.addRating(this.name['.key'], selected)
      }
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.center {
  align-items: center;
  justify-content: center;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s
}
.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
  opacity: 0
}
</style>



// WEBPACK FOOTER //
// Card.vue?61505bc6